export const SET_PERSON = 'setPerson'
export const SET_PERSONS = 'setPersons'
export const SET_PERSONS_SIMPLE = 'setPersonsSimple'
export const PERSON_RESET_STATE = 'personResetState'
export const SET_PERSON_PAGINATION = 'setPersonPagination'